export default async function GetInvestorOverview() {
    try {
        let url = window.RealestateService + `/api/PaymentDetails/GetInvestorOverview`
        let head = {
            "content-type": "application/json",
            "accept":"*/*"
        }
        let response = await fetch(url, {
            method: "GET",
            headers: head,
        }).then(res => res.json()).catch(res => res)

        return response
    }
    catch (ex){
        return {
            status:0,
            message:"",
            responseValue:[]
        }
    }
}